<template>

        <v-layout column>
            <!--STORES Active: {{ bottomNav }}-->
            <router-view/>
        </v-layout>

        <!-- CASO MAIS TARDE SE QUEIRA O SLIDER -->
        <!--<v-bottom-nav :value="true" color="transparent" app>-->

        <!--<v-btn color="primary" flat value="favorites" to="/stores/list">-->
        <!--<span>{{ $t('stores')}}</span>-->
        <!--<v-icon>fal fa-th-large</v-icon>-->
        <!--</v-btn>-->

        <!--<v-btn color="primary" flat value="nearby" to="/stores/maps">-->
        <!--<span>{{ $t('map')}}</span>-->
        <!--<v-icon>fal fa-map-marked-alt</v-icon>-->
        <!--</v-btn>-->
        <!--</v-bottom-nav>-->

</template>

<script>
    import {storesService} from '../../_services'
    import {getErrorMessage} from "../../_helpers";

    export default {
        name: "Stores",
        data: () => {
            return {
                bottomNav: 'nearby',
                stores: []
            }
        },
        mounted() {
            this.$store.dispatch("loader/setLoading", true);
            storesService.getAll().then(result => {
                    this.stores = result.results;
                    this.$store.dispatch("loader/setLoading", false);
                },
                error => {
                    getErrorMessage(error, 'Getting the Stores', this);
                }
            );

        },
        methods: {
            goToDetail: function (pk) {
                this.$router.push({name: 'stores-detail', params: {id: pk}})
            },
            getStoreById: function (pk) {
                if (this.stores.length === 0) {
                    return {}
                }
                return this.stores.find(st => st.id === pk)
            }
        }
    }
</script>

<style scoped>

</style>